export const canCopy = typeof navigator.clipboard?.writeText === 'function';

const copyToClipboard = (text: string, callback?: () => void, fallback?: () => void): void => {
  try {
    if (!canCopy) {
      throw new Error('copy to clipboard not enabled');
    }
    navigator.clipboard?.writeText(text);
    if (typeof callback === 'function') {
      callback();
    }
  } catch (error) {
    console.error(error);
    if (typeof fallback === 'function') {
      fallback();
    }
  }
};

export default copyToClipboard;
